import request from '@/utils/request'
import store from '@/store'
export function fetchCancelConcern(data) {
	const ids = data.map(item=>item.concernId)
	return request({
		url: '/concerned/deleteConcernedList',
		method: 'post',
		data:ids,
	})
}
export function fetchAddConcern(data) {
	return request({
		url: '/concerned/add',
		method: 'post',
		data,
	})
}
export function fetchConcernList(data) {
	return request({
		url: '/concerned/getConcernedList',
		method: 'get',
		data: {
			...data,
		},
	})
}
